import { render, staticRenderFns } from "./BtHome.vue?vue&type=template&id=3cdc894c&scoped=true&"
import script from "./BtHome.vue?vue&type=script&lang=js&"
export * from "./BtHome.vue?vue&type=script&lang=js&"
import style0 from "./BtHome.vue?vue&type=style&index=0&id=3cdc894c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdc894c",
  null
  
)

export default component.exports